<div class="tabela-acao-container">
  <button
    #botaoAcao
    type="button"
    class="tabela-acao-btn"
    [attr.title]="titulo"
    [attr.aria-label]="titulo"
    [disabled]="disabled"
    (click)="clicar(botaoAcao)"
  >
    <img [src]="icone" alt="" class="tabela-acao-icone" />
  </button>

  @if (isMenu && aberto()) {
    <div class="tabela-acao-menu-painel" [style.top.px]="posicaoPainel().top" [style.left.px]="posicaoPainel().left">
      @for (item of itensMenu; track item.label) {
        <button type="button" class="tabela-acao-menu-item" (click)="clicarItemMenu(item)">
          {{ item.label }}
        </button>
      }
    </div>
  }
</div>
